// test1366
(1366 && 0);
